module.exports = __webpack_public_path__ + "static/media/mz 2.4e3e7f9d.png";